import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";
import MediaGallery from "components/MediaGallery";

export default function Medias({ media }) {
  if (!media || !media.length) return null;

  return (
    <>
      <Divider sx={{ my: 3 }} />
      <MediaGallery media={media} title="Médias" showTitle />
    </>
  );
}

Medias.propTypes = {
  media: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ),
};
